import Vue from 'vue'
import Antd from 'ant-design-vue'
import dataV from '@jiaminghi/data-view'

import 'ant-design-vue/dist/antd.less'
import 'element-ui/lib/theme-chalk/index.css'
import '@static/styles/iconfont/iconfont.css'
Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(dataV)
